export enum AvaFollowUpOptions {
    Auto = 'auto',
    Set = 'set',
    Remind = 'remind',
}